module.exports = __webpack_public_path__ + "img/zh.de7f9dec.png";